import I18n from 'i18n-js';
import PropTypes from 'prop-types';
import React from 'react';
import NewsletterSignupForm from '../newsletter_signup_form';
import StringUtil from '../../../reverb-js-common/string_util';
import NoAccessImg from '../../../../images/icons/empty-states/no-access.svg';
import MustBeOnMobileImg from '../../../../images/icons/empty-states/must-be-on-mobile.svg';
import MustLogInImg from '../../../../images/icons/empty-states/must-login.svg';
import User from '../../user';
import constants from '../../shared/constants';
import { AppleAppStoreLink, GooglePlayStoreLink } from '../../shared/app_store_links';

const REASONS = constants.SALE_BUYER_INELIGIBILITY_REASONS;

class SaleIneligibleView extends React.Component {
  constructor(props) {
    super(props);
    this.onLoginClick = this.onLoginClick.bind(this);
    this.onRegistrationClick = this.onRegistrationClick.bind(this);
  }

  onLoginClick(e) {
    User.showInlineLogin(e, e.target);
  }

  onRegistrationClick(e) {
    User.showInlineRegistration(e, e.target);
  }

  get reason() {
    return this.props.sale.buyerIneligibilityReason;
  }

  get reasonKey() {
    return StringUtil.underscoreToCamelCase(this.reason);
  }

  get reasonTitle() {
    return I18n.t(`discovery.saleInformation.ineligible.${this.reasonKey}.title`,
      { defaults: [{ scope: 'discovery.saleInformation.ineligible.default.title' }] },
    );
  }

  get reasonDescription() {
    return I18n.t(`discovery.saleInformation.ineligible.${this.reasonKey}.description`,
      { defaults: [{ scope: 'discovery.saleInformation.ineligible.default.description' }] },
    );
  }

  get reasonCallToAction() {
    return I18n.t(`discovery.saleInformation.ineligible.${this.reasonKey}.callToAction`,
      { defaults: [{ scope: 'discovery.saleInformation.ineligible.default.callToAction' }] },
    );
  }

  callToActionButton(text, href) {
    return (
      <p className="not-found__message">
        <a className="button button--primary" href={href}>
          {text}
        </a>
      </p>
    );
  }

  loginCallToAction() {
    return (
      <p className="not-found__message">
        {/* disabling inline here so we can enable this rule globally, but this should be fixed the next time this file is touched */}
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a
          className="button button--primary"
          onClick={this.onLoginClick}
        >
          {I18n.t('discovery.saleInformation.ineligible.loginRequired.callToAction')}
        </a>
      </p>
    );
  }

  mobileCallToAction() {
    return (
      <div className="not-found__app-links">
        <div className="not-found__app-link not-found__app-link--ios">
          <AppleAppStoreLink linkLocation="sale-ended" userLocale="en" />
        </div>
        <div className="not-found__app-link not-found__app-link--google">
          <GooglePlayStoreLink linkLocation="sale-ended" userLocale="en" />
        </div>
      </div>
    );
  }

  imgSrc() {
    switch (this.reason) {
      case REASONS.MUST_BE_ON_MOBILE:
        return MustBeOnMobileImg;
      case REASONS.LOGIN_REQUIRED:
        return MustLogInImg;
      case REASONS.MUST_BE_ACTIVATED:
        return MustLogInImg;
      default:
        return NoAccessImg;
    }
  }

  renderCallToAction() {
    switch (this.reason) {
      case REASONS.MUST_BE_ON_MOBILE:
        return this.mobileCallToAction();
      case REASONS.LOGIN_REQUIRED:
        return this.loginCallToAction();
      case REASONS.MUST_BE_ACTIVATED:
        return this.callToActionButton(this.reasonCallToAction, '/users/activations');
      default:
        return this.callToActionButton(this.reasonCallToAction, '/promo/deals-and-steals');
    }
  }

  renderDescription() {
    if (this.reason === REASONS.LOGIN_REQUIRED) {
      return this.renderLoginDescription();
    }

    return (
      <p className="not-found__message">
        {this.reasonDescription}
      </p>
    );
  }

  renderLoginDescription() {
    return (
      <p className="not-found__message">
        {I18n.t('discovery.saleInformation.ineligible.loginRequired.description1')}
        {/* disabling inline here so we can enable this rule globally, but this should be fixed the next time this file is touched */}
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a onClick={this.onRegistrationClick}>
          {I18n.t('discovery.saleInformation.ineligible.loginRequired.link')}
        </a>
        {I18n.t('discovery.saleInformation.ineligible.loginRequired.description2')}
      </p>
    );
  }

  render() {
    const camelCaseSlug = this.props.saleSlug.replaceAll('-', '_');
    const signupReason = `sale_ineligible_${camelCaseSlug}`;

    return (
      <div>
        <div className="not-found not-found--ended-sale">
          <img
            src={this.imgSrc()}
            className="not-found__image"
            alt={this.reasonTitle}
          />
          <p className="not-found__message">
            {this.reasonTitle}
          </p>
          {this.renderDescription()}
          {this.renderCallToAction()}
        </div>
        <NewsletterSignupForm signupReason={signupReason} />
      </div>
    );
  }
}

SaleIneligibleView.propTypes = {
  sale: PropTypes.object.isRequired,
};

export default SaleIneligibleView;
